import { apiClient } from '../../gateways/api'
import type { BijlageTemplate } from '../types/BijlageTemplate'

export { patchBijlageTemplate }
export type { PatchBijlageTemplatePayload }

// Alleen de velden die de api laat aanpassen, zie update-bijlage-template.js.
// `reference`, `herplanDiff` and `waitFor` accept `null` to clear.
type PatchBijlageTemplatePayload = Pick<BijlageTemplate, '_id'> & {
  sortOrder?: number
  reference?: string | null
  herplanDiff?: number | null
  waitFor?: string | null
}

const patchBijlageTemplate = async ({
  bijlageTemplate,
}: {
  bijlageTemplate: PatchBijlageTemplatePayload
}): Promise<BijlageTemplate> => {
  const { data } = await apiClient({
    url: `/rest/bijlagetemplate/${bijlageTemplate._id}`,
    method: 'PATCH',
    data: bijlageTemplate,
  })
  return data
}
